import useChartColors from "Common/useChartColors";
import { useMemo } from "react";
import ReactApexChart from "react-apexcharts";
import { useSelector } from "react-redux";
import { RootState } from "../../slices";

interface LocationChartProps {
  chartId: string;
}

const LocationChart = ({ chartId }: LocationChartProps) => {
  const chartColors = useChartColors(chartId);
  const { chartData } = useSelector((state: RootState) => state.Dashboard);

  const monthLabels = useMemo(() => {
    const months = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];
    const now = new Date();
    return Array.from({ length: 12 }, (_, i) => {
      const d = new Date(now.getFullYear(), now.getMonth() - (11 - i), 1);
      return months[d.getMonth()];
    });
  }, []);

  const series = [
    {
      name: "Pedidos por Mês",
      data: chartData.monthlyOrders,
    },
  ];
  const options = {
    chart: {
      height: 350,
      type: "line" as const,
      zoom: {
        enabled: false,
      },
      margin: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
      },
      toolbar: {
        show: false,
      },
    },
    stroke: {
      show: true,
      curve: "smooth" as const,
      lineCap: "butt" as const,
      width: 2,
      dashArray: 0,
    },
    dataLabels: {
      enabled: false,
    },
    colors: chartColors,
    xaxis: {
      categories: monthLabels,
    },
  };
  return (
    <ReactApexChart
      dir="ltr"
      options={options}
      series={series}
      data-chart-colors='["bg-red-500"]'
      id="responseTimes"
      className="apex-charts"
      type="line"
      height={350}
    />
  );
};

export { LocationChart };
